import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
import useMediaQuery from '@mui/material/useMediaQuery';

import Divider from '@mui/material/Divider'; 
import Button from '@mui/material/Button';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import ClickAwayListener from '@mui/material/ClickAwayListener';
import Popper from '@mui/material/Popper';
import Paper from '@mui/material/Paper';

import LogoutOutlinedIcon from '@mui/icons-material/LogoutOutlined';
import AccountCircleOutlinedIcon from '@mui/icons-material/AccountCircleOutlined';
import KeyboardArrowDownOutlinedIcon from '@mui/icons-material/KeyboardArrowDownOutlined';

import Logout from './Logout';

import { useTheme } from '@mui/material/styles';
import { styled } from '@mui/material/styles';
import theme from '../../theme';

import useUser from '../../hook/useUser';
import { apiList } from '../../api/callAPI';
import * as basicConstants from '../../constants/basic';
import * as alertConstants from '../../constants/alertMsg';
import * as urlConstants from '../../constants/url';

import { LinkInternalNormal } from '../customComponent/link';
import {
  BoxFlexBetweenCenter
} from '../customComponent/box';

const CustomButton = styled(Button)(props => ({
  '&:hover': {
    backgroundColor: 'rgba(0, 0, 0, 0.04)'
  }
}))

const UserProfile = (props) => {
  const history = useHistory();
  const theme = useTheme();
  // const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  // const isDesktop = useMediaQuery(theme.breakpoints.up('md'));

  const { userData, setUserData, setAuthStatusMsg, alertMsg, setAlertMsg } = useUser();
  const { isDesktop, isMobile, color } = props;

  const [target, setTarget] = useState(null);
  const isOpen = Boolean(target);
  
  const handleMenuOpen = (e) => {
    setTarget(e.currentTarget);
  };

  const handleMenuClose = () => {
    setTarget(null);
  };

  return (
    <>
      {
        isDesktop &&
          <>
            <CustomButton
              startIcon={<AccountCircleOutlinedIcon />}
              endIcon={<KeyboardArrowDownOutlinedIcon />}
              onClick={handleMenuOpen}
              sx={{ color: '#fff', textTransform: 'none'}}
            >                  
              { userData.name || userData.username }                  
            </CustomButton>

            <Popper
              open={isOpen}
              anchorEl={target}
              placement='bottom'
              style={{
                zIndex: 2000,
              }}
            >
              <ClickAwayListener onClickAway={handleMenuClose}>
                <Paper sx={{ py: 1 }}>
                  <Box sx={{ pl: 2, pr: 2 }}>
                    <Typography >{ userData.name || userData.username }</Typography>
                    {
                      userData.email && 
                        <Typography variant="caption">{ userData.email }</Typography >
                    }
                  </Box>

                  <Divider sx={{ mt: 1.5, mb: 1 }} />

                  <BoxFlexBetweenCenter sx={{ display: 'flex', justifyContent: 'space-evenly' }}> 
                    <Logout color={color} />
                  </BoxFlexBetweenCenter> 
                </Paper>
              </ClickAwayListener>
            </Popper>
          </>
      }

      {
        isMobile && 
          <> 
            <Box
              sx={{
                display: 'flex'
              }}
            >
              <AccountCircleOutlinedIcon
                sx={{
                  width: '48px',
                  height: '48px'
                }}
              />
              <Box ml={1}>
                <Typography
                  sx={{
                    fontSize: '1.125rem',
                    fontWeight: 600
                  }}
                >
                  { userData.name || userData.username }
                </Typography>
  
                {
                  userData.email && 
                    <Typography variant="caption">{ userData.email }</Typography >
                }
              </Box>    
            </Box>      
          </>
      }
    </>
  )
}

export default UserProfile;